/** @jsx jsx */
import { jsx } from '@emotion/react';
import Spinner from '@atlaskit/spinner';
import { rootContainerStylesForLoaderWithDisplaytext, rootContainerStylesForLoaderWithoutDisplaytext } from '../link-picker/styled';

/**
 * Loader / skeleton for the Link Picker. Takes displayText prop - when no displayText is given the height of the skeleton
 * is shorter to prevent jump when loading in Link Picker.
 */
export var LoaderFallback = function LoaderFallback(_ref) {
  var hideDisplayText = _ref.hideDisplayText;
  return jsx("div", {
    css: hideDisplayText ? rootContainerStylesForLoaderWithoutDisplaytext : rootContainerStylesForLoaderWithDisplaytext,
    "data-testid": "link-picker-root-loader-boundary-ui"
  }, jsx(Spinner, {
    testId: "link-picker.component-loading-indicator",
    size: "medium"
  }));
};